export const gameLoadingContent = (media) => {
  let deviceType = window.localStorage.getItem("device_type") || "desktop";

  const logoPath = media?.image;

  return `
    <!DOCTYPE html>
    <html lang="en">
    <head>
      <meta charset="UTF-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no">
      <title>Launching...</title>
      <style>
        html, body {
          margin: 0;
          padding: 0;
          background-color: #000;
          font-family: sans-serif;
          height: 100%;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          overflow: hidden;
        }

        .launch-loader {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          color: #fff;
          min-height: 100vh;
          width: 100%;
          box-sizing: border-box;
          padding: 20px;
        }

        .rocket {
          max-width: 225px;
          // animation: float 1.5s ease-in-out infinite;
          margin-bottom: 8px;
        }

        @keyframes float {
          0% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
          100% { transform: translateY(0); }
        }

        .game-loader {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          color: #b19d9b;
        }


        @keyframes glitch {
          0%   { transform: translate(0); }
          20%  { transform: translate(-2px, 1px); }
          40%  { transform: translate(2px, -1px); }
          60%  { transform: translate(-1px, 2px); }
          80%  { transform: translate(1px, -2px); }
          100% { transform: translate(0); }
        }

        .scan-bar {
          width: 200px;
          height: 8px;
          background: #222;
          border: 1px solid #eb2828;
          margin-top: 20px;
          overflow: hidden;
          position: relative;
        }

        .scanner {
          width: 40px;
          height: 100%;
          background: linear-gradient(90deg, transparent, #ff0044, transparent);
          animation: scan 3s linear infinite;
        }

        @keyframes scan {
          0%   { transform: translateX(-40px); }
          100% { transform: translateX(200px); }
        }

        /* Modal Styles */
        #overlay {
          display: none;
          position: fixed;
          top: 0; left: 0;
          width: 100%; height: 100%;
          background-color: rgba(0, 0, 0, 0.7);
          z-index: 999;
        }

        #modal {
          display: none;
          position: fixed;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          background: white;
          color: #000;
          padding: 20px;
          border-radius: 8px;
          z-index: 1000;
          box-shadow: 0 0 15px rgba(255, 0, 0, 0.5);
          text-align: center;
        }

        #modal button {
          margin-top: 15px;
          padding: 10px 20px;
          font-weight: bold;
          cursor: pointer;
          background-color: #6e1a99;
          color: white;
          border: none;
          border-radius: 5px;
        }
          
        .typewriter {
          font-size: 1.2rem;
          color: white;
          position: relative;
          width: max-content;
          white-space: nowrap;
          letter-spacing: 4px;
          text-shadow: 0 0 5px #ba0430, 0 0 10px #F44336;
          text-align: center;
          padding-bottom: 8px;
        }

        .typewriter::after {
          content: "";
          animation: typing 3s steps(13) infinite;
          border-right: 1px solid white;
          padding-right: 4px;
        }

        @keyframes typing {
          0%   { content: ""; }
          7%   { content: "P"; }
          15%  { content: "Pl"; }
          23%  { content: "Ple"; }
          30%  { content: "Plea"; }
          38%  { content: "Pleas"; }
          45%  { content: "Please"; }
          53%  { content: "Please "; }
          61%  { content: "Please W"; }
          69%  { content: "Please Wa"; }
          76%  { content: "Please Wai"; }
          84%  { content: "Please Wait"; }
          92%  { content: "Please Wait."; }
          96%  { content: "Please Wait."; }
          100% { content: "Please Wait."; }
        }
      </style>
    </head>
    <body>
      <div class="launch-loader">
        <img class="rocket" src="${logoPath}" alt="Launching..." />
        <div class="game-loader">
          <div class="typewriter"></div>
          <div class="scan-bar">
            <div class="scanner"></div>
          </div>
        </div>
      </div>

      <!-- Modal and Overlay -->
      <div id="overlay"></div>
      <div id="modal">
        <p>Something went wrong. Please try again later.</p>
        <button onclick="window.close()">Close</button>
      </div>

      <script>
        setTimeout(() => {
          document.getElementById("overlay").style.display = "block";
          document.getElementById("modal").style.display = "block";
        }, 60000); // 60 seconds
      </script>
    </body>
    </html>
  `;
};
